var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9125_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 5.56027C18.206 5.82876 18.2285 6.2501 18.0048 6.54412L17.9377 6.62093L12.8119 11.7484L17.9406 16.8771C18.2335 17.17 18.2335 17.6449 17.9406 17.9378C17.6721 18.2063 17.2507 18.2286 16.9568 18.0049L16.88 17.9378L11.7512 12.8091L6.6268 17.9364C6.33396 18.2294 5.85903 18.2295 5.56614 17.9366C5.29765 17.6681 5.27514 17.2468 5.49882 16.9528L5.56592 16.876L10.6906 11.7484L5.56477 6.6226C5.27188 6.32971 5.27188 5.85483 5.56477 5.56194C5.83325 5.29345 6.25465 5.27108 6.54863 5.49482L6.62543 5.56194L11.7512 10.6878L16.8768 5.56049C17.1696 5.26754 17.6446 5.26738 17.9375 5.56027Z",
    fill: "#847577"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9125_3224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.90e74d4c4815c28120a4aa97db5c5252.svg";
export { ForwardRef as ReactComponent };